import React from 'react'

import { FaMicrophoneSlash } from 'react-icons/fa'

import { Box, Flex, Text } from '@chakra-ui/react'

const Separator = () => (
  <Box
    backgroundColor='#2D2E41'
    height='0.85em'
    mx={3}
    opacity={0.5}
    width='1px'
  />
)

interface CallHeaderIProps {
  title: string
  subtitle: string
  duration?: string
  isMuted?: boolean
}

export const CallHeader = ({
  title,
  subtitle,
  duration,
  isMuted,
}: CallHeaderIProps) => {
  return (
    <Flex direction='column' ml='20px' mr='20px'>
      <Text color='#282424' fontSize='16px' fontWeight='normal'>
        {title}
      </Text>

      <Flex alignItems='center' color='#2D2E41' fontSize='13px' opacity={0.5}>
        <Text noOfLines={1}>{subtitle}</Text>
        {duration && (
          <>
            <Separator />
            <Text>{duration}</Text>
          </>
        )}
        <Flex ml='20px'>
          {isMuted && <FaMicrophoneSlash opacity={0.6} size='20px' />}
        </Flex>
      </Flex>
    </Flex>
  )
}
